import { render, staticRenderFns } from "./articleDetailType3.vue?vue&type=template&id=edf6dbcc&scoped=true&"
import script from "./articleDetailType3.vue?vue&type=script&lang=ts&"
export * from "./articleDetailType3.vue?vue&type=script&lang=ts&"
import style0 from "./articleDetailType3.vue?vue&type=style&index=0&id=edf6dbcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf6dbcc",
  null
  
)

export default component.exports